export const GUEST_TOKEN_KEY = "try-smart-agenda-guest-token";
export const GUEST_PREVIEW_KEY = "try-smart-agenda-preview";

// Phase 2 (guest demo): token authorizing an anonymous visitor to run the real
// backend demo. Separate from the smart-agenda guest token above.
export const DEMO_GUEST_TOKEN_KEY = "demo-guest-token";
